/* SHILEX · HEADER v2 JS — logo SVG nítido, iconos custom, glass sticky, magnético, stagger.
   No toca la funcionalidad de Dawn (drawer/search/cart siguen igual). */
(function(){
  if(window.__clxhHeader) return; window.__clxhHeader=1;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  var ICONS = {
    search:'<circle cx="11" cy="11" r="7"></circle><path d="M20.2 20.2l-3.9-3.9"></path>',
    menu:'<path d="M4 7h16M4 12h16M4 17h16"></path>',
    account:'<circle cx="12" cy="8" r="3.6"></circle><path d="M4.6 20.4c.7-3.8 3.8-6 7.4-6s6.7 2.2 7.4 6"></path>',
    cart:'<path d="M6.6 8.4h10.8l.9 11.1a1 1 0 0 1-1 1.1H6.7a1 1 0 0 1-1-1.1l.9-11.1z"></path><path d="M9 8.4V7a3 3 0 0 1 6 0v1.4"></path>'
  };
  function swap(sel, key){
    document.querySelectorAll(sel).forEach(function(el){
      if(el.dataset.clxhIcon) return;
      var svg=el.querySelector('svg'); if(!svg) return;
      svg.setAttribute('viewBox','0 0 24 24'); svg.setAttribute('fill','none');
      svg.setAttribute('stroke','currentColor'); svg.setAttribute('stroke-width','1.4');
      svg.setAttribute('stroke-linecap','round'); svg.setAttribute('stroke-linejoin','round');
      svg.innerHTML=ICONS[key]; el.dataset.clxhIcon='1';
    });
  }
  ready(function(){
    /* ICONOS custom */
    swap('.header__icon--search','search');
    swap('summary.header__icon--menu, .header__icon--menu','menu');
    swap('.header__icon--account','account');
    swap('.header__icon--cart','cart');
    var icons=document.querySelectorAll('.header > .header__icons .header__icon, .header .header__icon');
    icons.forEach(function(el,i){ el.style.setProperty('--i', i); });

    /* LOGO: el logo ORIGINAL de la marca (la gota reemplaza la "E"), nítido en SVG (clx-wordmark2.svg) */
    var data=document.getElementById('clxh-data');
    var logoUrl=data?data.getAttribute('data-logo'):'';
    var link=document.querySelector('.header__heading a, a.header__heading-link, .header__heading-link');
    if(link && logoUrl && !link.classList.contains('clxh-logo')){
      link.classList.add('clxh-logo'); link.setAttribute('aria-label','Shilex · Inicio');
      var img=document.createElement('img'); img.className='clxh-mark-img';
      img.src=logoUrl; img.alt='Shilex'; img.decoding='async'; img.setAttribute('fetchpriority','high');
      link.appendChild(img);
    }

    /* DRAWER: índice para stagger */
    document.querySelectorAll('.menu-drawer__menu-item').forEach(function(el,i){ el.style.setProperty('--i', i%12); });

    /* NAV: quitar "BUSCAR" (duplica la lupa); atenuar nav cuando el drawer abre */
    document.querySelectorAll('[class*="ai-secondary-menu-list"] a, .menu-drawer__menu-item, .menu-drawer a').forEach(function(a){
      if(/^\s*buscar\s*$/i.test((a.textContent||'').trim())){ var li=a.closest('li')||a; li.style.display='none'; }
    });
    var menuSummary=document.querySelector('summary.header__icon--menu, .header__icon--menu');
    var menuDetails=menuSummary?menuSummary.closest('details'):null;
    if(menuDetails && window.MutationObserver){
      new MutationObserver(function(){ document.documentElement.classList.toggle('clxh-drawer-open', menuDetails.hasAttribute('open')); }).observe(menuDetails,{attributes:true,attributeFilter:['open']});
    }
    /* los toggles (menú/búsqueda) son <summary>: tras click de MOUSE retienen foco y dejan el anillo visible en reposo.
       Blur en interacción de mouse (e.detail>0); el teclado (e.detail===0) conserva el anillo para a11y. */
    document.querySelectorAll('summary.header__icon--menu, .header__icon--menu, summary.header__icon--search, .header__icon--search').forEach(function(el){
      el.addEventListener('click', function(e){ if(e.detail>0){ var self=this; setTimeout(function(){ try{ self.blur(); }catch(_){} }, 0); } });
    });

    /* STICKY glass al scroll */
    var sc=false;
    function onScroll(){ var s=window.scrollY>40; if(s!==sc){ sc=s; document.documentElement.classList.toggle('clxh-scrolled', s); } }
    onScroll(); window.addEventListener('scroll', onScroll, {passive:true});

    /* MAGNÉTICO en iconos (desktop fino, off en reduce-motion) */
    if(!reduce && window.matchMedia('(hover:hover) and (pointer:fine)').matches){
      document.querySelectorAll('.header .header__icon').forEach(function(el){
        var svg=el.querySelector('svg'); if(!svg) return;
        el.addEventListener('mousemove',function(e){ var r=el.getBoundingClientRect(); svg.style.transform='translate('+((e.clientX-(r.left+r.width/2))*0.2).toFixed(1)+'px,'+((e.clientY-(r.top+r.height/2))*0.2).toFixed(1)+'px)'; });
        el.addEventListener('mouseleave',function(){ svg.style.transform=''; });
      });
    }
  });
})();
